export default __webpack_public_path__ + "static/media/prenda2.ca4e30be.jpg";